module.exports = __webpack_public_path__ + "static/bnr-app-store-1468ec5c4d1acfc3fd1bb877b2ab82d4.svg";